'use client';

import React, { type ReactElement, useEffect, useState } from 'react';
import { AccountDrawerType, useDecisions, useOptimizely, usePageLayout } from '@libs/common-next';
import './OffersContainerOpti.scss';

export interface OffersDrawerProps {
    offerDrawerActive?: boolean;
}
export function OffersContainerOpti(): ReactElement | null {
    const [offerDrawerActive, setOfferDrawerActive] = useState(false);
    const abTestFlag = useDecisions('exp_loyalty_off');
    const { context } = useOptimizely();
    const { openAccountDrawer } = usePageLayout();
    useEffect(() => {
        if (offerDrawerActive) {
            openAccountDrawer(AccountDrawerType.OFFERS);
        }
    }, [offerDrawerActive, openAccountDrawer]);

    // TODO: [AC-4466] Will move styling and handle state in legacy header if AB test succeeds

    return !abTestFlag ? null : (
        <button
            type="button"
            title="Offers"
            data-testid="legacy-header-offers-links"
            className="legacy-header__offer"
            onClick={() => {
                openAccountDrawer(AccountDrawerType.OFFERS);
                context?.trackEvent('offer_header_clicks');
            }}
        >
            {/* TODO [AC-4466] add this icon to sparky */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.49963 4.23845C5.49963 4.48568 5.42632 4.72736 5.28897 4.93292C5.15162 5.13848 4.9564 5.29869 4.72799 5.3933C4.49958 5.48791 4.24825 5.51267 4.00577 5.46444C3.76329 5.4162 3.54057 5.29715 3.36575 5.12234C3.19093 4.94752 3.07188 4.72479 3.02365 4.48232C2.97542 4.23984 3.00017 3.98851 3.09478 3.7601C3.18939 3.53169 3.34961 3.33647 3.55517 3.19912C3.76073 3.06177 4.00241 2.98846 4.24963 2.98846C4.58115 2.98846 4.8991 3.12015 5.13352 3.35457C5.36794 3.58899 5.49963 3.90693 5.49963 4.23845ZM19.5466 11.7765L11.7736 19.5495C11.632 19.6927 11.4636 19.8066 11.2779 19.8847C11.0923 19.9628 10.893 20.0035 10.6916 20.0045C10.5098 20.0059 10.3295 19.9712 10.1611 19.9026C9.99275 19.8339 9.83964 19.7326 9.71063 19.6045L0.416634 10.3115C0.281988 10.1758 0.176926 10.0137 0.108079 9.83537C0.0392327 9.65705 0.00809579 9.46641 0.0166338 9.27545L-0.000366211 1.50346C0.00016376 1.10598 0.158433 0.72496 0.43968 0.444088C0.720927 0.163215 1.10216 0.00545466 1.49963 0.00545502L9.27363 0.019455H9.32963C9.51127 0.0183523 9.69134 0.0531186 9.85951 0.12176C10.0277 0.190401 10.1806 0.291567 10.3096 0.419455L19.5996 9.71045C19.8662 9.99196 20.0102 10.3678 19.9999 10.7553C19.9895 11.1429 19.8258 11.5105 19.5446 11.7775L19.5466 11.7765ZM18.4866 10.7155L9.28663 1.51546H9.27063L1.49963 1.50546L1.51963 9.27345V9.28846L10.7116 18.4885L18.4856 10.7195L18.4866 10.7155Z"
                    fill="#131313"
                />
            </svg>
        </button>
    );
}
